import { defineStore } from 'pinia';
import { Video } from '~/types';

export const useVideoPopupStore = defineStore('videoPopup', {
  state: () => ({
    video: null as Video | null,
  }),
  actions: {
    setVideo(video: Video) {
      this.video = video;
    },
    clearVideo() {
      this.video = null;
    },
  },
});
